import React from 'react';
import SquareButton from '@/components/SquareButton';
import Seo from '@/components/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" noIndex />
      <section className="block-cream">
        <div className="mx-auto max-w-[900px] px-5 py-24 sm:py-32 text-center">
          <div className="font-heading text-8xl sm:text-9xl font-extrabold text-[hsl(var(--c-mango-red))] leading-none">404</div>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl font-extrabold">That mango fell from the tree.</h1>
          <p className="mt-4 text-[hsl(var(--c-ink-soft))]">The page you’re looking for can’t be found.</p>
          <div className="mt-10">
            <SquareButton to="/" variant="orange" size="lg">Back To Home</SquareButton>
          </div>
        </div>
      </section>
    </>
  );
}
